import { FormType } from "@/enums";
import { useFormPropertyValueLookupProvider } from "@/providers";
import { Col, Row } from "antd";
import { useIntl } from "react-intl";
import {
  ProjectInfoLabel,
  ProjectInfoValue,
  ProjectInfoWrapper,
} from "../styled";

interface IProps {
  productCategory: string;
  projectType: string;
}

export const ProjectTitleInfo = ({ productCategory, projectType }: IProps) => {
  const { getPropertyValueDisplay } = useFormPropertyValueLookupProvider();
  const intl = useIntl();

  return (
    <ProjectInfoWrapper gutter={[64, 64]}>
      <Col>
        <Row>
          <ProjectInfoLabel>
            {intl.formatMessage({ id: "project.productCategory" })}
          </ProjectInfoLabel>
        </Row>
        <Row>
          <ProjectInfoValue>
            {getPropertyValueDisplay(
              FormType.Intake,
              "productCategory",
              productCategory
            ) || "n/a"}
          </ProjectInfoValue>
        </Row>
      </Col>
      <Col>
        <Row>
          <ProjectInfoLabel>
            {intl.formatMessage({ id: "project.projectType" })}
          </ProjectInfoLabel>
        </Row>
        <Row>
          <ProjectInfoValue>
            {getPropertyValueDisplay(
              FormType.Intake,
              "projectType",
              projectType
            ) || "n/a"}
          </ProjectInfoValue>
        </Row>
      </Col>
    </ProjectInfoWrapper>
  );
};
